import 'dotenv/config';
import axios from "axios";

export const api = axios.create({
  baseURL: process.env.API_URL || 'https://23136fv876.execute-api.sa-east-1.amazonaws.com/dev/create-report',
});
